import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { Navigate } from 'react-router-dom';

import { vibeCodedAppsRouteRef } from './routes';
import { cloudflareWorkersApiRef } from './api/types';
import { CloudflareWorkersClient } from './api/CloudflareWorkersClient';
import { VIBE_CODED_APPS_ROUTES } from './components/vibe-coded-apps/navigation';

const cloudflareWorkersApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: cloudflareWorkersApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new CloudflareWorkersClient({ discoveryApi, fetchApi }),
    }),
});

const vibeCodedAppsPage = PageBlueprint.make({
  params: {
    path: VIBE_CODED_APPS_ROUTES.root.path,
    title: VIBE_CODED_APPS_ROUTES.root.title,
    routeRef: vibeCodedAppsRouteRef,
    // The list, detail and wizard pages render their own BUI
    // <FullPage>/<Header>.
    noHeader: true,
    loader: () =>
      import('./components/vibe-coded-apps').then(m => <m.VibeRouter />),
  },
});

// The plugin's previous home; keeps old bookmarks and links working.
const legacyRedirectPage = PageBlueprint.make({
  name: 'legacy-redirect',
  params: {
    path: '/cloudflare-workers',
    noHeader: true,
    loader: async () => (
      <Navigate to={VIBE_CODED_APPS_ROUTES.root.path} replace />
    ),
  },
});

export const cloudflareWorkersPlugin = createFrontendPlugin({
  pluginId: 'cloudflare-workers',
  title: VIBE_CODED_APPS_ROUTES.root.title,
  routes: {
    vibeCodedApps: vibeCodedAppsRouteRef,
  },
  extensions: [cloudflareWorkersApi, vibeCodedAppsPage, legacyRedirectPage],
});

export default cloudflareWorkersPlugin;
